import { isFunction } from 'lodash'
export default {
  functional: true,
  name: 'KyeShortcuts',
  render (h, context) {
    const props = context.props
    const { shortcuts = [], handleShortcutClick } = props
    if (!Array.isArray(shortcuts) || !shortcuts.length) {
      return null
    }
    const className = {
      'kye-shortcuts-wrap': true,
    }
    const inner = () => {
      return shortcuts.reduce((coms, item) => {
        const { text, show, disabled, btnProps = {}, auth, style = {} } = item || {}
        if (show !== false) {
          const btnAttrs = {
            style,
            props: {
              type: 'text',
              ...btnProps,
              disabled: isFunction(disabled) ? disabled(props) : !!disabled,
              auth: isFunction(auth) ? auth(props) : auth
            },
            class: {
              'kye-shortcuts-wrap-btn': true
            },
            on: {
              click: () => {
                handleShortcutClick(item)
              }
            }
          }
          coms.push(
            <kye-button {...btnAttrs}>
              <div class='shortcut-text'>{text}</div>
            </kye-button>
          )
        }
        return coms
      }, [])
    }
    const content = inner()
    return <div class={className}>
      {
        content
      }
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/basic/shortcuts.js